export default __webpack_public_path__ + "static/media/retiro.26a821b8.png";